import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetCertificateOfRegistrationByIdFetchUrl,
  ICertificateOfRegistrationDetailsResponse,
} from "../../../../api/CircularEconomy/CertificateOfRegistration/ICertificateOfRegistration";
import { RootState } from "../../../../redux/store";

export interface CertificateOfRegistrationState {
  fetchStatus: string;
  error: any;
  certificateOfRegistrationResponse?: ICertificateOfRegistrationDetailsResponse;
}

const initialState: CertificateOfRegistrationState = {
  error: undefined,
  fetchStatus: "Loading...",
  certificateOfRegistrationResponse: undefined,
};

export const loadCertificateOfRegistrationAsync = createAsyncThunk(
  "certificateOfRegistration/load",
  async (licenseId: string) => {
    const response = await GetCertificateOfRegistrationByIdFetchUrl(licenseId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const certificateOfRegistrationSlice = createSlice({
  name: "certificateOfRegistration",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadCertificateOfRegistrationAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(
        loadCertificateOfRegistrationAsync.fulfilled,
        (state, action) => {
          state.fetchStatus = "idle";
          state.certificateOfRegistrationResponse = action.payload;
        }
      )
      .addCase(loadCertificateOfRegistrationAsync.rejected, (state, action) => {
        state.fetchStatus = "rejected";
        state.error = action.payload;
      });
  },
});

export const selectCertificateOfRegistrationResponse = (state: RootState) =>
  state.certificateOfRegistrationResponse;

export default certificateOfRegistrationSlice.reducer;
